module.exports = "/_next/static/images/john-ju-afd81dd54d481010fa5e06faf10c64f9.jpg";